// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 3H18V5H22V19H18V21H6V19H2V5H6V3ZM6 7H4V17H6V7ZM18 7V17H20V7H18Z"}}]};

const CardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'card-filled',
    ref,
    icon: element,
  },
));

CardFilledIcon.displayName = 'CardFilledIcon';

export default CardFilledIcon;
